
// store/actions/interviewActions.js
export const GET_PIPELINE_REQUEST = 'GET_PIPELINE_REQUEST';
export const GET_PIPELINE_SUCCESS = 'GET_PIPELINE_SUCCESS';
export const GET_PIPELINE_FAILURE = 'GET_PIPELINE_FAILURE';
export const CLEAR_PIPELINE_ERROR = 'CLEAR_PIPELINE_ERROR';
export const RESET_PIPELINE = 'RESET_PIPELINE';
export const GET_COUNTS_REQUEST = 'GET_COUNTS_REQUEST';
export const GET_COUNTS_SUCCESS = 'GET_COUNTS_SUCCESS';
export const GET_COUNTS_FAILURE = 'GET_COUNTS_FAILURE';

// Action Creators
const getPipelines = (tenant) => {
  return async (dispatch) => {
    dispatch({ type: GET_PIPELINE_REQUEST });
    try {
      const token = localStorage.getItem('token')
      const response = await fetch(`${tenant.getApiUrl('pipelines')}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();
      
      dispatch({
        type: GET_PIPELINE_SUCCESS,
        payload: data.res || data.data || []
      });
    } catch (error) {
      dispatch({
        type: GET_PIPELINE_FAILURE,
        payload: error.message
      });
    }
  };
};

const getFilteredPipelines = (tenant, status = []) => {
  return async (dispatch) => {
    dispatch({ type: GET_PIPELINE_REQUEST });
    try {
      const token = localStorage.getItem('token')
      const response = await fetch(`${tenant.getApiUrl('pipelines')}/status`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ status }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();
      
      dispatch({
        type: GET_PIPELINE_SUCCESS,
        payload: data.res || data.data || []
      });
    } catch (error) {
      dispatch({
        type: GET_PIPELINE_FAILURE,
        payload: error.message
      });
    }
  };
};

const clearPipelineError = () => ({
  type: CLEAR_PIPELINE_ERROR
});

const resetPipeline = () => ({
  type: RESET_PIPELINE
});


const getAllCounts = (tenant) => {
  return async (dispatch) => {
    dispatch({ type: GET_COUNTS_REQUEST });
    try {
      const token = localStorage.getItem('token')
      const response = await fetch(`${tenant.getApiUrl('counts')}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      if (!response.ok) {
        throw new Error('Failed to retrieve counts');
      }
      const data = await response.json();
      
      dispatch({ type: GET_COUNTS_SUCCESS, payload: data.res || [] });
    } catch (error) {
      dispatch({ type: GET_COUNTS_FAILURE, payload: error.message });
    }
  };
}

export { getPipelines, clearPipelineError, resetPipeline, getAllCounts, getFilteredPipelines };